import { render, staticRenderFns } from "./EditerBasicGadgetV3.vue?vue&type=template&id=115f20e0&scoped=true&"
import script from "./EditerBasicGadgetV3.vue?vue&type=script&lang=ts&"
export * from "./EditerBasicGadgetV3.vue?vue&type=script&lang=ts&"
import style0 from "./EditerBasicGadgetV3.vue?vue&type=style&index=0&id=115f20e0&lang=scss&scoped=true&"
import style1 from "./EditerBasicGadgetV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f20e0",
  null
  
)

export default component.exports